import React, { CSSProperties, ReactNode, useState } from 'react'

interface ModalProps {
  isOpen: boolean
  onClose: () => void
  children: ReactNode
  customStyle?: CSSProperties | undefined
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  customStyle,
}) => {
  const [isAnimating, setIsAnimating] = useState(false)

  const handleClose = () => {
    setIsAnimating(true)
    setTimeout(() => {
      onClose()
      setIsAnimating(false)
    }, 300) // Adjust the timing to match your CSS transition duration
  }

  return (
    <>
      {isOpen && (
        <div
          className={`fixed inset-0 flex items-center justify-center z-50 ${isAnimating ? 'opacity-0' : 'opacity-100'}`}
        >
          <div
            className="fixed inset-0 bg-overlay opacity-50"
            onClick={handleClose}
          ></div>
          <div
            style={customStyle}
            className="absolute bg-white p-6 rounded-lg shadow-lg z-50"
          >
            {children}
          </div>
        </div>
      )}
    </>
  )
}

export default Modal
